import React, { useState } from "react";

import { ApiINNCompany } from "../../api/ApiINNCompany";

import { InputEditVer1 } from "../UI/InputEditVer1";

import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";

import { SiteModalToolbarBtn } from "./SiteModalToolbarBtn";

import { ManagerPicker } from "./ManagerPicker";

import { CcV4Toggle } from "../UI/CcV4Toggle";

import stateRegion from "../../state/state.region";

import { BtnOutlineV4 } from "../UI/button/BtnOutlineV4";

import { SiteModalHeader } from "../UI/SiteModalHeader";

import { SiteFormField } from "../UI/SiteFormField";
import RolesState from "../../api/RolesState";

export const CompanyEditForm = ({
  inn,

  innLabel,

  country,

  kpp,

  nameCompany,

  companyAddress,

  descriptions,

  managerDisplay,

  supportManagerDisplay,

  isPartner,

  isActive,

  setKpp,

  setNameCompany,

  setCompanyAddress,

  setDescriptions,

  onCancel,

  onSave,

  onCountryChange,

  onManagerSelect,

  onSupportManagerSelect,

  onPartnerChange,

  onArchiveChange,
}) => {
  const [managerPickerOpen, setManagerPickerOpen] = useState(false);
  const [supportManagerPickerOpen, setSupportManagerPickerOpen] =
    useState(false);

  return (
    <section
      className="card dash-card company-edit-panel"
      aria-labelledby="company-edit-title"
    >
      <SiteModalHeader
        title="Редактирование компании"
        titleId="company-edit-title"
        toolbarWrap={false}
        toolbar={
          <SiteModalToolbarBtn
            variant="close"
            onClick={onCancel}
            title="Отменить редактирование"
          />
        }
      />

      <div className="company-edit-meta">
        <div className="company-edit-inn-row">
          <span className="site-form-label">{innLabel}</span>

          <span className="company-edit-inn-value company-card-v4-mono">
            {inn}
          </span>

          <ApiINNCompany
            inn={inn}
            setNameCompany={setNameCompany}
            setCompanyAddress={setCompanyAddress}
            setKpp={setKpp}
          />
        </div>
      </div>

      <div className="company-edit-grid">
        <SiteFormField label="КПП">
          <InputEditVer1
            className="site-form-control"
            placeholder="КПП"
            value={kpp ?? ""}
            onChange={(e) => setKpp(e.target.value)}
          />
        </SiteFormField>

        <SiteFormField label="Страна">
          <select
            className="site-form-control site-form-select"
            onChange={onCountryChange}
            defaultValue=""
            aria-label="Страна компании"
          >
            <option value="" disabled hidden>
              {country}
            </option>

            {stateRegion.collectionRegion.map((r) => (
              <option key={r.id} value={JSON.stringify(r)}>
                {r.tag_country}
              </option>
            ))}
          </select>
        </SiteFormField>

        <SiteFormField label="Название" full>
          <InputEditVer1
            className="site-form-control"
            placeholder="Название компании"
            value={nameCompany ?? ""}
            onChange={(e) => setNameCompany(e.target.value)}
          />
        </SiteFormField>

        <SiteFormField label="Адрес" full>
          <InputEditVer1
            className="site-form-control"
            placeholder="Адрес"
            value={companyAddress ?? ""}
            onChange={(e) => setCompanyAddress(e.target.value)}
          />
        </SiteFormField>

        <SiteFormField label="Описание" full>
          <textarea
            className="site-form-control company-edit-textarea"
            placeholder="Дополнительное описание или комментарии"
            value={descriptions ?? ""}
            onChange={(e) => setDescriptions(e.target.value)}
            rows={3}
          />
        </SiteFormField>

        <SiteFormField
          label="Ответственный менеджер"
          full
          className="company-edit-manager-field"
          as="div"
        >
          <div className="company-edit-manager-row">
            <span
              className={
                managerDisplay?.muted
                  ? "req-value req-value-muted"
                  : "req-value"
              }
            >
              {managerDisplay?.text ?? "менеджер не заполнен"}
            </span>

            {RolesState.patch_company ? (
              <BtnOutlineV4
                text="Изменить"
                onClick={() => {
                  setSupportManagerPickerOpen(false);
                  setManagerPickerOpen(true);
                }}
              />
            ) : null}
          </div>

          {managerPickerOpen ? (
            <ManagerPicker
              onSelect={onManagerSelect}
              onClose={() => setManagerPickerOpen(false)}
            />
          ) : null}
        </SiteFormField>

        <SiteFormField
          label="Менеджер сопровождения"
          full
          className="company-edit-manager-field"
          as="div"
        >
          <div className="company-edit-manager-row">
            <span
              className={
                supportManagerDisplay?.muted
                  ? "req-value req-value-muted"
                  : "req-value"
              }
            >
              {supportManagerDisplay?.text ?? "менеджер не заполнен"}
            </span>

            {RolesState.patch_company ? (
              <BtnOutlineV4
                text="Изменить"
                onClick={() => {
                  setManagerPickerOpen(false);
                  setSupportManagerPickerOpen(true);
                }}
              />
            ) : null}
          </div>

          {supportManagerPickerOpen ? (
            <ManagerPicker
              onSelect={onSupportManagerSelect}
              onClose={() => setSupportManagerPickerOpen(false)}
            />
          ) : null}
        </SiteFormField>

        {/* <div className="site-form-field site-form-field--full company-edit-partner-field"> */}
        <CcV4Toggle
          active={!!isPartner}
          label="Партнёр"
          onClick={onPartnerChange}
        />
        <CcV4Toggle
          active={!isActive}
          label="В архиве"
          onClick={onArchiveChange}
        />
        {/* </div> */}
      </div>

      <footer className="site-modal-footer">
        <BtnPrimaryv4
          onClick={onSave}
          text="Подтвердить изменения"
          footerSize
        />

        <BtnOutlineV4 onClick={onCancel} text="Отменить редактирование" />
      </footer>
    </section>
  );
};
